/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable arrow-body-style */

import * as Papa from 'papaparse';
import { CsvJson, LaEdgeApiItem } from '../../types';
import { getFileName } from './getFileName';
import { laIdTypeColorAssignment } from '../../laIdTypeColorAssignment';

export async function downloadGraphCsv(
  searchValue: string,
  edges: LaEdgeApiItem[]
) {
  const json = withLevelZero(getCsv(edges));

  const csv = Papa.unparse(json);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const href = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', href);
  link.setAttribute('download', getFileName(searchValue, 'csv'));
  link.click();
  return { csv, json };
}

function getCsv(edges: LaEdgeApiItem[]): CsvJson[] {
  const csvJson: CsvJson[] = edges.map((edge) => ({
    Level: edge.depth,
    'Node A Type': laIdTypeColorAssignment.getItem(edge.sourceNodeType).label,
    'Node A Value': edge.sourceNodeValue,
    'Node B Type': laIdTypeColorAssignment.getItem(edge.targetNodeType).label,
    'Node B Value': edge.targetNodeValue,
  }));
  return csvJson;
}

function withLevelZero(json: CsvJson[]): CsvJson[] {
  const level0: CsvJson = {
    Level: 0,
    'Node A Type': json[0]['Node A Type'],
    'Node A Value': json[0]['Node A Value'],
    'Node B Type': '',
    'Node B Value': '',
  };
  return [level0, ...json];
}
